import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/shared/Button.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { config } from 'utils/config';
import {
  StyledActions,
  StyledIcon,
  StyledText,
  StyledTitle,
  StyledWrapper
} from './ChangePasswordRequestSent.styled';
import { ChangePasswordRequestSentProps } from './ChangePasswordRequestSent.types';

export const ChangePasswordRequestSent: React.FC<
  ChangePasswordRequestSentProps
> = ({ onAccept, manfrediteEmail }) => {
  const { t } = useI18n('portal-settings');

  return (
    <StyledWrapper>
      <StyledIcon>
        <FontAwesomeIcon icon={faEnvelope} />
      </StyledIcon>
      <StyledTitle>
        {t('portal-settings.account.form.password.confirm.sent.title')}
      </StyledTitle>
      <StyledText>
        <HtmlTrans
          ns="portal-settings"
          i18nKey="portal-settings.account.form.password.confirm.sent.text"
          components={{
            supportLink: (
              <a
                href={`mailto:${config.supportEmail}`}
                target="_blank"
                rel="noreferrer"
              />
            )
          }}
          values={{
            supportEmail: config.supportEmail,
            manfrediteEmail
          }}
        />
      </StyledText>
      <StyledActions>
        <Button
          variant="primary"
          aria-label={t(
            'portal-settings.account.form.password.confirm.sent.actions.cancel'
          )}
          onClick={onAccept}
        >
          <FontAwesomeIcon icon={faCheckCircle} />
          <span aria-hidden="true">
            {t(
              'portal-settings.account.form.password.confirm.sent.actions.cancel'
            )}
          </span>
        </Button>
      </StyledActions>
    </StyledWrapper>
  );
};
